import React, { useEffect, useState } from 'react';
import Drawer from 'react-modern-drawer';
import systemListingService from '../SystemListingServices';

export default function AnalysisCodeUpsert(param: any) {

    let [mechanical, setMechanical] = useState(0);
    let [statusSave, setStatusSave] = useState("");
    let [analysis_type, setAnalysis_type] = useState("");
    let [analysisCode, setanalysisCode] = useState<any>([])
    let [analysis_profite, setAnalysis_profite] = useState("");

    console.log(param)

    useEffect(() => {
        onReset();

        if (param?.activeCategory == "Recorded Music") {
            setAnalysis_type("Sales")
        }
        if (param?.activeCategory == "Mechanical") {
            setAnalysis_type("Sales")
        }

        if (param?.activeCategory == "Publishing") {
            setAnalysis_type("publishingInc")
        }

        if (param?.activeCategory == "Costs") {
            setAnalysis_type("costs ")
        }

        if (param?.activeCategory == "Advances") {
            setAnalysis_type("advances")
        }

        if (param?.activeCategory == "Licensing") {
            setAnalysis_type("flatFee")
        }

    }, [param])

    const onFieldChange = (field: any, value: string) => {

        console.log(field)
        console.log(value)

        setanalysisCode((prev: any) => ({
            ...prev, [field]: value
        }));

        console.log(analysisCode)
    };

    const closeDrawer = () => { param.closeDrawer() };

    const onReset = () => {
        analysisCode = []
        setanalysisCode(() => [])
    };

    const onSave = () => {
        console.log(analysisCode)


        if (analysis_type == "sales") {
            analysisCode.salesCode = 1;
            analysisCode.costsCode = 0;
            analysisCode.advanceCode = 0;
            analysisCode.flatFeeCode = 0;
            analysisCode.publCode = 0;
        }

        if (analysis_type == "flatFee") {
            analysisCode.salesCode = 0;
            analysisCode.costsCode = 0;
            analysisCode.advanceCode = 0;
            analysisCode.flatFeeCode = 1;
            analysisCode.publCode = 0;
        }

        if (analysis_type == "publishingInc") {
            analysisCode.salesCode = 0;
            analysisCode.costsCode = 0;
            analysisCode.advanceCode = 0;
            analysisCode.flatFeeCode = 0;
            analysisCode.publCode = 1;
        }

        if (analysis_type == "costs") {
            analysisCode.salesCode = 0;
            analysisCode.costsCode = 1;
            analysisCode.advanceCode = 0;
            analysisCode.flatFeeCode = 0;
            analysisCode.publCode = 0;
        }

        if (analysis_type == "advances") {
            analysisCode.salesCode = 0;
            analysisCode.costsCode = 0;
            analysisCode.advanceCode = 1;
            analysisCode.flatFeeCode = 0;
            analysisCode.publCode = 0;
        }

        if (analysisCode && analysisCode?.analysisCode?.length > 0 && analysisCode?.group?.length > 0 && analysisCode?.description?.length > 0) {
            console.log("save")
            systemListingService.saveSalesAnalysissales(analysisCode).then(respond => {
                statusSave = "success"
                setStatusSave(statusSave)
            })

        } else {
            console.log("falsil")
            statusSave = "fail"
            setStatusSave(statusSave)
        }
        setTimeout(() => {
            statusSave = ""
            setStatusSave(statusSave)
        }, 5000);

    };

    return (<>

        <Drawer open={param.editDawer} direction='right' className='react-drawer allowHscroll ' size={800}>

            <div className="pull-right ws-6 box full-height-vh">

                <div className="ws-12 bg-blue ">
                    <h1 className="pull-left text-center mt mll">Add  Analysis Code ( {param?.activeCategory} ) </h1>
                    <i className="icon-close pull-right pLarge" onClick={closeDrawer}></i>
                </div>

                <div className="box-content">

                    {statusSave == "success" && <div className='ws-12 alert alert-success'>  Analysis code  has been saved successfully </div>}
                    {statusSave == "fail" && <div className='ws-12 alert alert-danger'>  There was a problem submitting your request, one or more fields are missing or incorrect  </div>}

                    {/* Body */}
                    <div className="ws-12 ">
                        <div className="ws-6 ps">
                            <label className="ws-12 text-bold">  Code<span className="ac-required">*</span> </label>
                            <input className="ws-11" value={analysisCode.analysisCode ? analysisCode.analysisCode : ""} onChange={(e) => onFieldChange("analysisCode", e.target.value)} placeholder="Enter code" />
                        </div>

                        <div className="ws-6 ps">
                            <label className="ws-12 text-bold">DIM 1 Db</label>
                            <input className="ws-11" value={analysisCode?.analysisDIM1 ?? ""} onChange={(e) => onFieldChange("analysisDIM1", e.target.value)} placeholder="DIM 1 Db" />
                        </div>

                        <div className="ws-6 ps">
                            <label className="ws-12 text-bold">  Group<span className="ac-required">*</span>  </label>
                            <input className="ws-11" value={analysisCode.group ?? ""} onChange={(e) => onFieldChange("group", e.target.value)} placeholder="Enter group" />
                        </div>

                        <div className="ws-6 ps">
                            <label className="ws-12 text-bold">DIM 2 Cr</label>
                            <input className="ws-11" value={analysisCode.analysisDIM2 ?? ""} onChange={(e) => onFieldChange("analysisDIM2", e.target.value)} placeholder="DIM 2 Cr" />
                        </div>

                        <div className="ws-6 ps">
                            <label className="ws-12 text-bold">
                                Description<span className="ac-required">*</span>
                            </label>
                            <input className="ws-11" value={analysisCode.description ?? ""} onChange={(e) => onFieldChange("description", e.target.value)} placeholder="Enter description" />
                        </div>

                        <div className="ws-6 ps">
                            <label className="ws-12 text-bold">DIM 3 Db</label>
                            <input className="ws-11" value={analysisCode.analysisDIM3 ?? ""} onChange={(e) => onFieldChange("analysisDIM3", e.target.value)} placeholder="DIM 3 Db" />
                        </div>

                        <div className="ws-6 ps">
                            <label className="ws-12 text-bold">DIM 4 Cr</label>
                            <input className="ws-11" value={analysisCode.analysisDIM4 ?? ""} onChange={(e) => onFieldChange("analysisDIM4", e.target.value)} placeholder="DIM 4 Cr" />
                        </div>


                        <div className="ws-6 ps">
                            <label className="text-bold pt ws-12 pb">Mechanical</label>
                            <div className='ws-12'>
                                <label className="switch"  >
                                    <input type="checkbox" name="mechanical" checked={mechanical === 1} onChange={() => setMechanical(mechanical == 1 ? 0 : 1)} />
                                    {mechanical === 1 && <span className="slider round text-left white pm pts" >Yes</span>}
                                    {mechanical === 0 && <span className="slider round text-right white pm pts sliderOff">No</span>}
                                </label>

                            </div>
                        </div>

                        {/* Points / Profits + Type */}
                        <div className="ws-12" style={{ gridColumn: "1 / -1" }}>

                            <div className='ws-6 ps'>
                                <label className="ws-12 text-bold">Points / Profits</label>
                                <select className="ws-11"   >
                                    <option value="both">Both</option>
                                    <option value="pointsOnly">Points Only</option>
                                    <option value="profitOnly">Profit Only</option>
                                    <option value="neither">Neither</option>
                                </select>
                            </div>

                            <div className='ws-6 ps'>
                                <label className="ws-12 text-bold">Type</label>
                                <select className="ws-11" value={analysis_type} onChange={(e) => setAnalysis_type(e.target.value)}>
                                    <option value="sales">Sales</option>
                                    <option value="flatFee">Flat Fee</option>
                                    <option value="publishingInc">Publishing</option>
                                    <option value="costs">Costs</option>
                                    <option value="advances">Advances</option>
                                </select>
                            </div>
                        </div>
                    </div>

                    {/* Footer */}
                    <div className="box-footer ws-12 pull-right">
                        <button type="button" className="icon-btn delete pull-right" onClick={closeDrawer}>x Close</button>
                        <button type="button" className="icon-btn delete pull-right" onClick={onReset}>↻ Reset</button>
                        <button type="button" className="icon-btn edit pull-right" onClick={onSave}>✔ Save </button>
                    </div>
                </div>

            </div>

        </Drawer>
    </>)
}